import { CloudUpload} from "@mui/icons-material";
import { Button, styled } from "@mui/material";
import React from "react";
// import { VisuallyHidden } from "rsuite";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const FileUploadWithPreview = (props) => {
  return (
    <div className="container mt-4">
      {/* <h2 className="mb-4">Upload Images</h2> */}

      {/* File Upload Input */}
      <div className="mb-3">
        <Button
          component="label"
          role={undefined}
          variant="contained"
          // fullWidth
          tabIndex={-1}
          startIcon={<CloudUpload />}
        >
          Gallery Images
          <VisuallyHiddenInput
            type="file"
            multiple
            accept="image/*"
            onChange={props.handleFileChange}
            ref={props.fileInputRef}
            className="form-control"
          />
        </Button>
        {/* <input
          type="file"
          multiple
          accept="image/*"
          onChange={props.handleFileChange}
          ref={props.fileInputRef}
          className="form-control"
        />
        <label>File Choosen</label> */}
      </div>

      {/* Preview Grid */}
      <div className="row">
        {props.previews.map((preview, index) => (
          <div key={index} className="col-md-3 mb-4">
            <div
              className="position-relative border rounded p-2 text-center"
              style={{
                height: "150px", // Ensure consistent height
              }}
            >
              {/* Image Preview */}
              <img
                src={preview}
                alt="Preview"
                className="img-fluid rounded"
                style={{
                  maxHeight: "150px",
                  objectFit: "cover",
                }}
                loading="lazy"
              />

              {/* Remove Button */}
              <button
                className="btn btn-danger btn-sm position-absolute"
                style={{
                  top: "5px",
                  right: "5px",
                  borderRadius: "50%",
                }}
                onClick={() => props.handleRemove(index)}
              >
                ✕
              </button>

              {/* File Name */}
              <div
                className="text-truncate mt-2"
                title={props?.files[index]?.name} // Tooltip for full file name
                style={{
                  fontSize: "12px",
                }}
              >
                {props?.files[index]?.name}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FileUploadWithPreview;
